export default "__VITE_ASSET__DAIS9unh__"